module.exports = __webpack_public_path__ + "static/media/inverterDefault.cd73321c.png";